module.exports = __webpack_public_path__ + "img/dfs-logo.a6884272.png";